import React from 'react';

interface IconShieldProps {
    iconClasses?: string;
}

const IconShield: React.FC<IconShieldProps> = ({ iconClasses }) => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-shield ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M14.0013 25.6663C14.0013 25.6663 23.3346 20.9997 23.3346 13.9997V5.83301L14.0013 2.33301L4.66797 5.83301V13.9997C4.66797 20.9997 14.0013 25.6663 14.0013 25.6663Z"
                stroke="currentColor"
                strokeWidth="2.33333"
            />
        </svg>
    );
};

export default IconShield;
